export default __webpack_public_path__ + "static/media/logo-white.18d0d806.png";